<template>
  <v-container grid-list-xs>
    <v-row justify="center">
      <v-col cols="7">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>List OF Users</v-toolbar-title>
            <v-spacer></v-spacer>
            <addUser :AtFinshed="ShowAllUSers"></addUser>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              flat
              :headers="headers"
              :items="usersList"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:item.pass="{ item }">
                <PasswordReset
                  v-if="item.UserType.toUpperCase() !== 'ADMIN'"
                  :key="item._id"
                  :User="item"
                />
                <v-icon color="primary" v-else>mdi-account-lock</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import addUser from "@/components/AddLoginUser.vue";
import PasswordReset from "@/components/users/userChangePass.vue";
export default {
  components: { addUser, PasswordReset },
  data() {
    return {
      usersList: [],
      headers: [
        {
          text: "User Name",
          align: "left",
          sortable: false,
          value: "UserName",
        },
        { text: "Type", value: "UserType" },
        { text: "Full Name", value: "FullName" },
        { text: "Phone", value: "Userphone" },
        { text: "Pass_Reset", value: "pass" },
      ],
    };
  },
  methods: {
    ShowAllUSers() {
      this.$store
        .dispatch("GET_DATA_ONLY", "/users/itus")
        .then(result => {
          this.usersList = result.data;
          // console.log(result);
        })
        .catch(() => {
          // console.log(error);
        });
    },
  },
  mounted() {
    this.ShowAllUSers();
  },
};
</script>
